(function fullTextDefinition() {
    'use strict';
    angular.module('Entities')
        .service('fullTextProcessService', [
            'restUrlBuilder', function fullTextProcessService(restUrlBuilder) {

                this.getStatus = function getStatus() {
                    return restUrlBuilder.all('fullText/Status').get();
                };

                this.getStatusEngine = function getStatusEngine() {
                    return restUrlBuilder.all('fullText/Engine').get();
                };

                this.removeFullTextTask = function removeFullTextTask() {
                    return restUrlBuilder.all('fullText/Stop').get();
                };

                this.addFullTextTask = function addFullTextTask() {
                    return restUrlBuilder.all('fullText/Start').get();
                };
                this.runFullTextTask = function addFullTextTask() {
                    return restUrlBuilder.all('fullText/Execute').get();
                };
            }
        ]);
})();